<h1 mat-dialog-title>{{ data.dialogTitle }}</h1>
<div mat-dialog-content *ngIf="isLoading">Loading Data, Please Wait...</div>
<div mat-dialog-content *ngIf="!isLoading">
  <form class="edit-interactive-subscription-dialog-form">
    <mat-form-field>
      <mat-label>Name (required)</mat-label>
      <input matInput
             name="repotSubscriptionType.name"
             [(ngModel)]="data.reportSubscriptionType.name" />
    </mat-form-field><br />
    <mat-form-field>
      <mat-label>Description (required)</mat-label>
      <input matInput
             name="reportSubscriptionType.description"
             [(ngModel)]="data.reportSubscriptionType.description" />
    </mat-form-field><br />
    <mat-form-field>
      <mat-label>Standard Types</mat-label>
      <mat-select name="selectedReportStandardType" [(ngModel)]="selectedReportStandardType">
        <mat-option *ngFor="let standardType of data.reportStandardTypes"
                    [value]="standardType">{{ standardType.name }}</mat-option>
      </mat-select>
    </mat-form-field><br />
    <ng-container>
      <button mat-raised-button color="primary" (click)="onAddStandardType()">Add</button>
    </ng-container><br />
    <mat-form-field>
      <mat-chip-list #standardTypeChipList>
        <mat-chip *ngFor="let stdType of data.selectedReportStandardTypes"
                  [removable]="removable"
                  (removed)="onRemoveStandardType(stdType)">
          Standard Type: {{ stdType.name }}
          <mat-icon matChipRemove>x</mat-icon>
        </mat-chip>
      </mat-chip-list>
    </mat-form-field><br />
    <mat-form-field>
      <mat-label>Embedded Types</mat-label>
      <mat-select name="selectedReportEmbeddedType" [(ngModel)]="selectedReportEmbeddedType">
        <mat-option *ngFor="let embeddedType of data.reportEmbeddedTypes"
                    [value]="embeddedType">{{ embeddedType.name }}</mat-option>
      </mat-select>
    </mat-form-field><br />
    <ng-container>
      <button mat-raised-button color="primary" (click)="onAddEmbeddedType()">Add</button>
    </ng-container><br />
    <mat-form-field>
      <mat-chip-list #embeddedTypeChipList>
        <mat-chip *ngFor="let embType of data.selectedReportEmbeddedTypes"
                  [removable]="removable"
                  (removed)="onRemoveEmbeddedType(embType)">
          Standard Type: {{ embType.name }}
          <mat-icon matChipRemove>x</mat-icon>
        </mat-chip>
      </mat-chip-list>
    </mat-form-field><br />
    <ng-container>
      <button mat-raised-button color="primary" (click)="editLicense()">
        Edit License
      </button>
    </ng-container><br />
  </form>
</div>
<div mat-dialog-actions>
  <button mat-raised-button color="primary" (click)="onConfirmClick()">
    Save Subscription
  </button>
  <button mat-raised-button (click)="onCancelClick()">Cancel</button>
</div>
